import { render, staticRenderFns } from "./General.vue?vue&type=template&id=7087c621&scoped=true"
import script from "./General.vue?vue&type=script&lang=js"
export * from "./General.vue?vue&type=script&lang=js"
import style0 from "./General.vue?vue&type=style&index=0&id=7087c621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7087c621",
  null
  
)

export default component.exports